// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Bm8a","image":"styles_image__2_VW5","text":"styles_text__39txR"};